import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, contextMenuTransport, downloadDataTransport, numberFormat, tooltip_class} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    axios.post(url, filterParam).then(res => {

        let data = res.data;

        console.log("data", data)

        // group the data: I want to draw one line per group
        var sumstat = d3.nest() // nest function allows to group the calculation per level of a factor
            .key(function (d) {
                return d.dim1_name;
            })
            .entries(data);


        // Add X axis --> it is a date format
        var x = d3.scaleLinear()
            .range([0, chart.width]);

        //Add Y axis
        var y = d3.scaleLinear()
            .range([chart.height, 0]);

        x.domain(d3.extent(data, function (d) {
            return d.dim2_name;
        }))

        d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip' + divId.id)
            .offset([-10, 0])
            .html(function (d) {
                return d.dim1_name + colonAnnotation + d.dim2_name + colonAnnotation + numberFormat(d.metric1)
            })


        console.log("nestsumstat", sumstat)

        // append the svg object to the body of the page
        var svg = d3.select(divId).selectAll("*").remove();

        // Add an svg element for each group. The will be one beside each other and will go on the next row when no more room available
        svg = d3.select(divId)
            //  .attr("class","card")
            .classed("bo-row", "true")
            .selectAll(".svg")
            .data(sumstat)
            .enter()
            .append("svg")
            .classed("bo-card", true)
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 100 + chart.margin.top + chart.margin.bottom)
            .append("g")
            .attr("transform",
                "translate(" + 15 + "," + chart.margin.top + ")")
            .attr("id", function (d) {
                return d.key;
            })

        sumstat.forEach(function (d) {

            svg = d3.select("#" + CSS.escape(d.key));

            y.domain([0, d3.max(d.values, function (d) {
                return d.metric1;
            })])


            svg.append("g")
                .attr("transform", "translate(0," + chart.height + ")")
                .attr("display", "none")
                .call(d3.axisBottom(x).ticks(3));


            svg.append("g")
                .attr("display", "none")
                .call(d3.axisLeft(y).ticks(5));


            // appending image
            svg.append("svg:image")
                .attr("y", -20)
                .attr("x", 50)
                .attr('width', "70")
                .attr('height', "50")
                .attr("margin-left", "auto")
                .attr("margin-right", "auto")
                .attr("xlink:href", function (d) {
                    return d.values[d.values.length - 1].dim3_name
                })     // Specify your icon in unicode
                .on('contextmenu', contextMenuTransport(downloadDataTransport))

            // Draw the line
            svg
                .append("path")
                .attr("fill", "none")
                .attr("stroke", "#1f77b4")
                .attr("stroke-width", 1.9)
                .attr("d", function (d) {
                    return d3.line()
                        .x(function (d) {
                            return x(d.dim2_name);
                        })
                        .y(function (d) {
                            return y(d.metric1) + 100;
                        })(d.values)


                })

            // Add titles
            svg
                .append("text")
                .attr("y", 50)
                .attr("x", 90)
                .style("font-size", "13px")
                .style("font-weight", "bold")
                .style("text-anchor", "middle")
                .append("a")
                .attr('pointer-events', function (d) {
                    return d.values[d.values.length - 1].dim4_name == '' ? 'none' : 'block'
                })
                .attr("fill", function (d) {
                    return d.values[d.values.length - 1].dim4_name == '' ? "black" : "blue"
                })
                .attr("xlink:href", function (d) {
                    return d.values[d.values.length - 1].dim4_name
                })
                .attr('target', '_BLANK')
                .text(function (d) {
                    return (d.key)
                })

            //Add metric
            svg
                .append("text")
                .attr("y", 90)
                .attr("x", 90)
                .style("font-size", "30px")
                .style("font-weight", "bold")
                .style("text-anchor", "middle")
                .attr("fill", "#7f7f7f")
                .text(function (d) {
                    return numberFormat(d.values[d.values.length - 1].metric1)
                })


            svg.selectAll("dot")
                .data(function (d) {
                    return d.values
                })
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", function (d) {
                    return x(d.dim2_name);
                })
                .attr("cy", function (d) {
                    return y(d.metric1) + 100;
                })
                .attr("fill", "#1f77b4")
                .on('mouseover', y1tip.show)
                .on('mouseout', y1tip.hide)


            svg.call(y1tip);


        })
    })
}
